module.exports = __webpack_public_path__ + "img/product20.095bcbca.png";